export enum FlightTimeType {
  EARLY_MORNING = 'earlyMorning',
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
}
export const FLIGHT_PERIODS = [
  { value: FlightTimeType.EARLY_MORNING, hour: '03:00:00' },
  { value: FlightTimeType.MORNING, hour: '09:00:00' },
  { value: FlightTimeType.AFTERNOON, hour: '15:00:00' },
  { value: FlightTimeType.EVENING, hour: '21:00:00' },
];

export const FLIGHT_PERIODS_HOURS = [
  { value: '12 AM', hour: '00:00:00' },
  { value: '1 AM', hour: '01:00:00' },
  { value: '2 AM', hour: '02:00:00' },
  { value: '3 AM', hour: '03:00:00' },
  { value: '4 AM', hour: '04:00:00' },
  { value: '5 AM', hour: '05:00:00' },
  { value: '6 AM', hour: '06:00:00' },
  { value: '7 AM', hour: '07:00:00' },
  { value: '8 AM', hour: '08:00:00' },
  { value: '9 AM', hour: '09:00:00' },
  { value: '10 AM', hour: '10:00:00' },
  { value: '11 AM', hour: '11:00:00' },
  { value: '12 PM', hour: '12:00:00' },
  { value: '1 PM', hour: '13:00:00' },
  { value: '2 PM', hour: '14:00:00' },
  { value: '3 PM', hour: '15:00:00' },
  { value: '4 PM', hour: '16:00:00' },
  { value: '5 PM', hour: '17:00:00' },
  { value: '6 PM', hour: '18:00:00' },
  { value: '7 PM', hour: '19:00:00' },
  { value: '8 PM', hour: '20:00:00' },
  { value: '9 PM', hour: '21:00:00' },
  { value: '10 PM', hour: '22:00:00' },
  { value: '11 PM', hour: '23:00:00' },
];
